/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IRepaymentCount, IRepaymentSlice } from './repaymentSlice.types';

const initialState: IRepaymentSlice = {
  repaymentCount: {
    upcoming: 0,
    paid: 0
  },
  nextRepayment: null,
  repaymentAmount: 0,
  repaymentPayNowModal: false
};

export const repaymentSlice = createSlice({
  name: 'repayment',
  initialState,
  reducers: {
    setRepaymentCount: (state: IRepaymentSlice, action: PayloadAction<IRepaymentCount>) => {
      const { payload } = action;
      state.repaymentCount = payload;
    },
    setNextRepayment: (state: IRepaymentSlice, action: PayloadAction<any>) => {
      const { payload } = action;
      state.nextRepayment = payload;
    },

    setRepaymentPayNowModal: (state: IRepaymentSlice, action: PayloadAction<any>) => {
      const { payload } = action;
      state.repaymentPayNowModal = payload;
    },

    setRepaymentAmount: (state: IRepaymentSlice, action: PayloadAction<number>) => {
      const { payload } = action;
      state.repaymentAmount = payload;
    }
  }
});

const { actions, reducer } = repaymentSlice;
export const { setRepaymentCount, setNextRepayment, setRepaymentAmount, setRepaymentPayNowModal } =
  actions;
export default reducer;
